<script>
import {
  layoutMethods,
  billsPaymentMethods
} from "@/state/helpers";
import Swal from "sweetalert2";
import { getModuleAccess } from '@/router/helper.js'

export default {
  page: {
    title: "Bills Payment Provider",
  },
  data() {
    return {
      title: "Bills Payment Provider",
      providerId: 0,
      billsProvider: {
        providerId: null,
        providerStatus: null,
        providerCode: null,
        providerName: null,
        description: null,
        providerApiEndpoint: null
      },
      formExitChecker: {
        providerId: null,
        providerStatus: null,
        providerCode: null,
        providerName: null,
        description: null,
        apiEndpoint: null
      },
      formValidation: {
          providerName: false,
          providerCode: false,
          apiEndpoint: false
      },
      isSubmitted: false,
      formStatus:'',
      billsPaymentModule: {
        access: {
          update: true
        }
      },
      isUpdateForm:false,
    };
  },
  components: {
    
  },
  methods: {
    ...layoutMethods,
    ...billsPaymentMethods,
    async getDetails(){
      await this.actionBillsPaymentProvider({
          action: "details",
          body: {"providerId":this.providerId}
      })
      .then((res) => {
        console.log(res);
        this.isUpdateForm = true;
        this.billsProvider = {...res["message"]};
        console.log("this", this.billsProvider);
        this.formExitChecker = {...this.billsProvider};
      }).catch((e)=>{
        console.log("error while getting provider list",e);
      });
    },
    checkForm() {
      this.formValidation.providerName = false;
      this.formValidation.providerCode = false;
      this.formValidation.apiEndpoint = false;
      var status = true;

      if(this.isEmpty(this.billsProvider.providerName)){
        status = false;
        this.formValidation.providerName = true;
      }
      if(this.isEmpty(this.billsProvider.providerCode)){
        status = false;
        this.formValidation.providerCode = true;
      }
      if(this.isEmpty(this.billsProvider.apiEndpoint)){
        status = false;
        this.formValidation.apiEndpoint = true;
      }
      if(status){ 
        this.isSubmitted = true;
        this._updateProvider();
      }
    },
    _updateProvider() {
      var providerObj = { ...this.billsProvider };
      if(this.providerId > 0){
          this.updateProvider(providerObj);
      } else {
          this.insertProvider(providerObj);
      }
    },
    async insertProvider(providerObj){
        await this.actionBillsPaymentProvider({
            action: "create",
            body: {...providerObj}
        })
        .then((res) => {
          console.log("INSERT billsProvider",res);
          this.billsProvider = providerObj;
          this.formExitChecker = providerObj;
          Swal.fire(
            "Created Successful!",
            res["message"],
            "success"
            );
          this.$router.push(
            this.$route.query.redirectFrom || {
              name: "Bills Payment Provider",
            }
          );
        }).catch((e)=>{
            Swal.fire(
                "Create Failed!",
                Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${providerObj.providerName} was not created.`,
                "error"
            );
            this.isSubmitted = false;
        });
        console.log("providerObj",JSON.stringify(providerObj));
        this.isSubmitted = false;
        this.formStatus = "";
    },
    async updateProvider(providerObj) {
      this.formStatus = "Updating billsProvider...";
      console.log("providerObj: ", providerObj);
      await this.actionBillsPaymentProvider({
          action: "update",
          body: {...providerObj}
      })
      .then((res) => {
        console.log(res);
        Swal.fire(
          "Update Successful!",
          `${providerObj.providerName} has been updated.`,
          "success"
        );
        this.formStatus = "";
        this.isSubmitted = false;
        this.billsProvider = providerObj;
        this.formExitChecker = providerObj;
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "Bills Payment Provider",
          }
        );
      }).catch((e)=>{
          Swal.fire(
            "Update Failed!",
            Object.prototype.hasOwnProperty.call(e, "message")? e.message : `${providerObj.providerName} was not updated.`,
            "error"
          );
          this.formStatus = "";
          this.isSubmitted = false;
      });
    },
    leaveform(next){
        if(JSON.stringify(this.billsProvider) == JSON.stringify(this.formExitChecker)){
          next();
          return;
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "you want to leave this page?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '##804997',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                next();
            }else{
                return;
            }
        })
    },
    isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
    },
  },
  async mounted() {
    this.providerId = this.$route.params.providerId;
    this.billsProvider.providerId = this.providerId = this.$route.params.providerId;
    console.log("Mounted", this.billsProvider);
    this.changeTitle({
      title: (this.providerId > 0 ? "Edit" : "Add") + " Bills Payment Provider",
    });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: 'Bills Payment Provider', to: { name: 'Bills Payment Provider'} },
        { text: "Details", to: { name: "Bills Payment Provider Form" } }
      ],
    });

    // await this.getProvider();
    if(this.providerId > 0){
      await this.getDetails();
    }

    // get the module access for checking if user has create, read, update, and/or delete access
    await getModuleAccess('Products', 'Bills Payment', 'Bills Payment Provider')
    .then((access) => this.billsPaymentModule.access = access);
  },
  computed: {
  },
  beforeRouteLeave(to, from, next) {
      // console.log("billsProvider::", JSON.stringify(this.billsProvider));
      // console.log("formExitChecker::", JSON.stringify(this.formExitChecker));
      // console.log("providerLogo::", JSON.stringify(this.providerLogo));
      
      if(JSON.stringify(this.billsProvider) != JSON.stringify(this.formExitChecker)){
        this.leaveform(next);
      }else{
        next();
      }
  }
};
</script>

<template>
  <div class="">
    <ValidationObserver v-slot="{ handleSubmit, reset }">
      <b-form @submit.prevent="handleSubmit(checkForm)" @@reset.prevent="reset">
        <div class="d-flex flex-md-row flex-column mb-3">
          <div class="px-lg-2">
            <div class="card">
              <div class="card-body" style="width: 620px">
                <div class="row">
                  <label v-if="!billsPaymentModule.access.update" class="form-label medium fw-bold text-danger">Note: Your access is limited. You cannot update a Bills Provider.</label>
                  <div class="col-md-12 mb-3">
                    <div class="form-check form-switch">
                      <label class="form-check-label" for="flexSwitchCheckDefault">Active</label>
                      <input
                        class="form-check-input"
                        v-model="billsProvider.providerStatus"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                      />
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Provider Code<span style="color: red">*</span></label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Code"
                      v-model="billsProvider.providerCode"
                      :class="{
                          'is-invalid' : formValidation.providerCode
                      }"
                    />
                      <!-- :disabled="true" -->
                    <div
                        v-if="formValidation.providerCode"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div><!--end of billsProvider name-->
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Provider Name<span style="color: red">*</span></label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Name"
                      v-model="billsProvider.providerName"
                      :class="{
                          'is-invalid' : formValidation.providerName
                      }"
                    />
                      <!-- :disabled="true" -->
                    <div
                        v-if="formValidation.providerName"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">Description</label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter Description"
                      v-model="billsProvider.description"
                      :class="{
                          'is-invalid' : formValidation.description
                      }"
                    />
                  </div>
                  <div class="col-md-12 mb-3">
                    <label class="form-label small fw-bold">API Endpoint<span style="color: red">*</span></label>
                    <b-form-input
                      type="text"
                      class="form-control"
                      placeholder="Enter API Endpoint"
                      v-model="billsProvider.apiEndpoint"
                      :class="{
                          'is-invalid' : formValidation.apiEndpoint
                      }"
                    />
                      <!-- :disabled="true" -->
                    <div
                        v-if="formValidation.apiEndpoint"
                        class="invalid-feedback">
                        This value is required.
                    </div>
                  </div>

                  <div v-if="!isSubmitted" class="row">
                    <div class="col-md-6 mt-3">
                      <b-button :disabled="isUpdateForm ? !billsPaymentModule.access.update:!billsPaymentModule.access.create" variant="primary" class="w-sm w-100p" type="submit">{{isUpdateForm ? "Update" : "Save"}}</b-button>
                    </div>
                    <div class="col-md-6 mt-3">
                      <router-link :to="{ name: 'Bills Payment Provider', params: {} }" class="tc-white">
                        <b-button variant="light" class="w-sm w-100p" type="button" >Cancel</b-button>
                      </router-link>
                    </div>
                  </div>
                  <div v-else>
                    <p>{{ formStatus }}</p>
                  </div>
                </div><!-- end of row-->
              </div><!-- end of card body -->
            </div>
            <!-- end of card-->
          </div>
          <!-- end of card form-->
        </div>
        <!--end of flex-->
      </b-form>
      <!-- end of the form--> 
    </ValidationObserver><!-- end of validation observer-->
    <!-- billsProvider Selection -->
    
    <!-- end billsProvider Select -->
  </div>
  <!-- end of row-->
</template>
